"use strict";

/* global CONTENT, CONTENT_TARGET, urlParams, LoadingBar, runningMode, urlHistory, componentHandler, Events, Login, NaN, Promise */

/**
 * Project specific colors
 * @type object
 */
const color = {
  main: "rgb(139, 195, 74)",
  second: "rgb(255,171,64)",
};
/**
 * Duration of normal animation in milliseconds.
 * Note: Some animations multily this value.
 * @type Number
 */
const animationTime = 250;

/**
 * This is like a version number. Use only unsigned integer.
 * This Numer should be used in <i>post()</i> to let the sever know wich
 * client version is currently used.
 * @type Number
 */
const buildNumber = 1;

/**
 * Use this var instead of normal global vars so you can see all global vars
 * at this point. Initialize your own with <i>null</i>.<br/>
 * <b>Never delete this!</b>
 * @type object
 */
const globalData = {
  /**
   * The Framework contain some login and logout functions. They based on this
   * object. Some example fields are <i>email</i>, <i>name</i>,
   * <i>date_of_birth</i>, <i>password</i>. For add or delete fields check the
   * manual. If <i>user</i> is <i>null</i>, no user is logged in.
   * @type object
   */
  user: null,
};

let API_PATH = "http://localhost:1337/api/";
switch (window.location.origin) {
  case "http://localhost":
  case "https://localhost":
    API_PATH = `${window.location.origin}:1337/`;
    break;
  case "http://map.bscheuch.bre.red.local":
    API_PATH = `http://map.bscheuch.bre.red.local:1337/`;
    break;
  case "https://test.datapicker.de":
    API_PATH = "https://api.test.datapicker.de/api/";
    break;
  case "https://map.datapicker.de":
    API_PATH = "https://api.map.datapicker.de/api/";
    break;
  default:
    API_PATH = `${window.location.origin}/api/`;
}

/**
 * DOM pointar to MDL snackbar
 * @type Node
 */
let snackbar = null;

/**
 * After Hummingbird start, this will be object with controll functions of the LoadingBar.
 * @type Object
 */
let loadingBar = null;

let autocompleete;
let lng;
let schema;
let restCollection;
let reporter;

document.addEventListener("DOMContentLoaded", hummingbirdStart);

function hummingbirdStart() {
  document.removeEventListener("DOMContentLoaded", hummingbirdStart);

  //iOS work arounds
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    //fastclick.js is a work around to avoid the 300ms delay on iOS devices
    const script = document.createElement("script");
    script.src = "js/libs/fastclick.min.js";
    script.onload = function () {
      new FastClick(document.body);
    };
    document.head.appendChild(script);

    //workaround for safari mdl-checkbox and mdl-radio bug
    Events.bind(
      document.body,
      "label.mdl-checkbox > *, label.mdl-radio > *, label.mdl-switch > *",
      "click",
      function () {
        this.parentNode.click();
      }
    );
  }

  // ---- initialize modules start ----
  reporter = new Reporter();

  snackbar = document.getElementById("snackbar");
  snackbar.show = function (options) {
    if (!options.message) {
      throw new Error("Snackbar requires message");
      return;
    }

    options.timeout = options.timeout || 5000;
    snackbar.MaterialSnackbar.showSnackbar(options);
  };

  urlParams.init();
  loadingBar = LoadingBar.init();
  autocompleete = new AutoCompleete();
  lng = new Lng("de");
  schema = new Schema();
  moment.locale("de");
  restCollection = {};
  for (let i in schema) restCollection[i] = new Rest(i);

  // ---- initialize modules end ----

  //critical components
  CONTENT_TARGET.init()
    .then(() => CONTENT.init())
    .then(() => runningMode.init())
    .then(() => urlHistory.init())
    .catch((err) => {
      console.error("Hummingbird stopped");
      throw err;
    });

  //useServiceWorker();

  // ---- mdl-navigation__link start ----

  //get the view names from Lng
  const navNodes = document.querySelectorAll(
    ".mdl-navigation__link:not(.login):not(.logout)"
  );
  for (let i = 0, len = navNodes.length; i < len; i++) {
    const node = navNodes[i];
    const viewName = node.dataset.view;
    node.querySelector("label").textContent = lng.get(
      snakeCaseToCamelCase(viewName + "s")
    );
  }

  Events.bind(
    document.querySelector("nav.mdl-navigation"),
    ".mdl-navigation__link:not(.login):not(.logout)",
    "click",
    function (e) {
      e.preventDefault();

      //get view name from node.dataset.view
      let view = this.dataset.view;
      if (view === undefined) {
        console.error("dataset.view not defined");
        return;
      }
      view = view.toUpperCase();

      //get view from CONTENT object
      if (Object.keys(CONTENT).indexOf(view) === -1) {
        console.error('View "' + view + '" not found in CONTENT');
        return;
      }

      //go to view
      CONTENT_TARGET.changeContent(CONTENT[view]);

      //hide mdl menu
      //document.querySelector('.mdl-layout').MaterialLayout.drawerToggleHandler_();
    }
  );

  /*document.querySelector('nav a.mdl-navigation__link.login').addEventListener('click', function () {
     //hide mdl menu
     document.querySelector('.mdl-layout').MaterialLayout.drawerToggleHandler_();
     Login.login();
     });*/
  document
    .querySelector("nav a.mdl-navigation__link.logout")
    .addEventListener("click", function () {
      //hide mdl menu
      //document.querySelector('.mdl-layout').MaterialLayout.drawerToggleHandler_();
      //Login.logout();
      CONTENT.LOGIN.functions
        .logout()
        .then(() => CONTENT_TARGET.changeContent(CONTENT.LOGIN))
        .catch(() => snackbar.show({ message: "Logout fehlgeschlagen" }));
    });

  // ---- mdl-navigation__link end ----

  // ---- drawer slide gesture ----
  let lastTouch = null;
  const touchBorderGape = 60;
  const mdlDrawerNodes = document.querySelectorAll(
    ".mdl-layout__drawer, .mdl-layout__obfuscator"
  );

  //show drawer by sliding from left border to middle over document
  document.addEventListener("touchmove", function (e) {
    //no affect of multitouch
    if (e.touches.length !== 1) {
      lastTouch = null;
      return;
    }

    const currentTouch = e.touches[0];

    //catch first touch event
    if (lastTouch === null) {
      //take only touches near the right body border

      if (currentTouch.clientX < touchBorderGape)
        //touches on left side
        lastTouch = currentTouch;
      return;
    }

    //reset last touch, if it is in middle of the screen
    if (currentTouch.clientX > touchBorderGape) {
      lastTouch = null;
      return;
    }

    const diffX = currentTouch.clientX - lastTouch.clientX;
    const diffY = currentTouch.clientY - lastTouch.clientY;

    //more vertical then horizontal move
    if (Math.abs(diffY) >= Math.abs(diffX)) {
      lastTouch = null;
      return;
    }

    if (diffX > 0) {
      //touch direction is right and cursor is on left side
      //show menu

      mdlDrawerNodes[0].classList.add("is-visible");
      mdlDrawerNodes[1].classList.add("is-visible");
    }
    //store the event to check future event
    lastTouch = currentTouch;
  });

  // -- drag drawer
  let drawerWidth = mdlDrawerNodes[0].getBoundingClientRect().width;
  let drawerToutchXDiff = 0;
  let drawerToutchX = null;
  let drawerLastToutch = null;
  let drawerIsScrolling = false;

  //start drag
  mdlDrawerNodes[0].addEventListener("touchstart", function (e) {
    //store distance to right drawer edge
    drawerToutchXDiff = drawerWidth - e.touches[0].pageX;

    //disable css animation
    this.style.webkitTransitionDuration = "0ms";
    this.style.transitionDuration = "0ms";
  });

  //calculate drag
  mdlDrawerNodes[0].addEventListener("touchmove", function (e) {
    if (drawerIsScrolling) return;

    //no affect of multitouch
    if (e.touches.length !== 1) {
      drawerLastToutch = null;
      return;
    }

    const currentTouch = e.touches[0];

    //catch first touch event
    if (drawerLastToutch === null) {
      drawerLastToutch = currentTouch;
      return;
    }

    //only on first move
    if (drawerToutchX === null) {
      const diffX = currentTouch.pageX - drawerLastToutch.pageX;
      const diffY = currentTouch.pageY - drawerLastToutch.pageY;

      //more vertical then horizontal move
      if (Math.abs(diffY) > Math.abs(diffX)) {
        drawerIsScrolling = true;
        return;
      }
    }

    //prevent scrolling
    e.preventDefault();

    //calculate new transformX
    let newX = currentTouch.pageX - drawerWidth + drawerToutchXDiff;
    //set min and max
    newX = Math.min(0, newX);
    newX = Math.max(-drawerWidth, newX);

    //apply new transformX
    this.style.webkitTransform = "translateX(" + newX + "px)";
    this.style.transform = "translateX(" + newX + "px)";

    //store value to touchend
    drawerToutchX = newX;
  });

  //drag end
  mdlDrawerNodes[0].addEventListener("touchend", function (e) {
    //reset js css values
    this.style.webkitTransform = null;
    this.style.transform = null;
    this.style.webkitTransitionDuration = null;
    this.style.transitionDuration = null;

    drawerLastToutch = null;
    drawerIsScrolling = false;

    //undefined on click
    if (drawerToutchX === null) return;

    //drawerToutchX is >0 on touch direction right
    //hide mdl drawer if swiped 30% left
    if (drawerToutchX !== 0 && drawerWidth / -drawerToutchX < 3) {
      const that = this;
      const transitionDuration =
        parseInt(this.style.transitionDuration) ||
        parseInt(this.style.webkitTransitionDuration);

      this.style.webkitTransitionTimingFunction = "ease-out";
      this.style.transitionTimingFunction = "ease-out";

      setTimeout(function () {
        that.style.webkitTransitionTimingFunction = null;
        that.style.transitionTimingFunction = null;
      }, transitionDuration);

      mdlDrawerNodes[0].classList.remove("is-visible");
      mdlDrawerNodes[1].classList.remove("is-visible");
    }
    drawerToutchX = null;
  });

  // ---- drawer slide gesture end ----
}

function useServiceWorker() {
  if (navigator.serviceWorker !== undefined) {
    navigator.serviceWorker
      .register("ServiceWorker.js")
      .then(function (registration) {
        // Registration was successful
        console.log(
          "ServiceWorker registration successful with scope: ",
          registration.scope
        );
        globalData.serviceWorkerReg = registration;
      })
      .catch(function (err) {
        // registration failed :(
        console.log("ServiceWorker registration failed: ", err);
      });
  }
}
